import { Address } from "viem";
import { TokenBalanceQueryOptions } from "./useTokenBalance";
import { useAddressesByNetwork } from "./useAddressesByNetwork";
import { useTokenBalance } from "./useTokenBalance";

export const useLooksBalance = (address: Address, queryOptions?: TokenBalanceQueryOptions) => {
  const addressesByNetwork = useAddressesByNetwork();
  return useTokenBalance({ contractAddress: addressesByNetwork.LOOKS, address, queryOptions });
};
